export default "__VITE_ASSET__69d19590__";